import PhoneCountryCodeInput from "common/form/inputs/phone/country_code";
import FieldWrapper from "common/form/enhancers/redux_form_field_wrapper";

export default FieldWrapper(PhoneCountryCodeInput);
